__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-budget-write/').replace(/[/]{3,}/g, "/");